import Vue from 'vue';
import campaignTransformer from './../../transformers/campaign';

const success = (campaign, resolve) => {
  resolve(campaignTransformer.fetch(campaign));
};

const failed = (errors, reject) => {
  reject(campaignTransformer.fetch(errors));
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .get(`news_campaigns/${id}`)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/campaign/show.js